import axios, { AxiosInstance } from 'axios';

interface APIRequestProps {
    url: string;
    requestMethod?: 'GET' | 'POST' | 'PUT' | 'DELETE';
    requestBody?: any;
    urlType?: string,
    params?: Record<string, any>;
}

export const APIRequest = async ({
    url,
    requestMethod = 'GET',
    requestBody = null,
    params = {}, 
}: APIRequestProps): Promise<any> => {
    const apiUrl = process.env.REACT_APP_API_URL;

    const apiClient: AxiosInstance =await axios.create({
        baseURL:apiUrl, 
        headers: {
            "Content-type": "application/json",
        }
    });


    // Perform the request based on the request method
    switch (requestMethod.toUpperCase()) {
        case 'GET':
            return apiClient.get(url, { params }); // Pass `params` to GET request
        case 'POST':
            return apiClient.post(url, requestBody);
        case 'PUT':
            return apiClient.put(url, requestBody);
        case 'DELETE':
            return apiClient.delete(url);
        default:
            throw new Error('Unsupported request method.');
    }
}
